var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignOutinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.393 2.833h7.11a1.18 1.18 0 001.184-1.166A1.18 1.18 0 009.504.5h-7.11C1.09.5.023 1.55.023 2.833v16.334c0 1.283 1.067 2.333 2.37 2.333h7.11a1.18 1.18 0 001.184-1.167 1.18 1.18 0 00-1.184-1.166h-7.11V2.833z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.937 10.592L17.63 7.337c-.38-.373-1.019-.117-1.019.408v2.089H8.318A1.18 1.18 0 007.133 11a1.18 1.18 0 001.185 1.167h8.294v2.088c0 .525.64.782 1.007.409l3.306-3.255a.568.568 0 00.012-.817z",
    fill: "inherit"
  })));
}

export default SvgSignOutinline;